module.exports = __webpack_public_path__ + "8b789662f68ceca9c200b322d009ec7b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-72.svg
// module id = 594
// module chunks = 0